import {
  CameraIcon,
  ChatBubbleLeftEllipsisIcon,
  ClipboardDocumentCheckIcon,
  ExclamationTriangleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";

const KIND_ICONS = {
  photo: CameraIcon,
  document_pin: CameraIcon,
  deviation: ExclamationTriangleIcon,
  note: ChatBubbleLeftEllipsisIcon,
  checklist: ClipboardDocumentCheckIcon,
};

export const DrawingPlacementOverlay = ({
  t,
  pending,
  ghost,
  onCancel,
  onWantSketchChange,
}) => {
  if (!pending) return null;

  const Icon = KIND_ICONS[pending.kind] || ExclamationTriangleIcon;
  const showSketchToggle =
    pending.kind === "document_pin" && typeof onWantSketchChange === "function";

  return (
    <>
      {ghost && (
        <div
          className="pointer-events-none absolute z-[26]"
          style={{ left: ghost.left, top: ghost.top, transform: "translate(-50%, -100%)" }}
        >
          <div
            className="grid h-7 w-7 place-items-center rounded-md text-white shadow-lg"
            style={{ background: pending.color || "#2b6ef0" }}
          >
            <Icon className="h-4 w-4" />
          </div>
          <div
            className="mx-auto h-3 w-0.5"
            style={{ background: pending.color || "#2b6ef0" }}
          />
          <div
            className="mx-auto h-2.5 w-2.5 rounded-full border-2 border-white shadow"
            style={{ background: pending.color || "#2b6ef0" }}
          />
        </div>
      )}

      <div className="pointer-events-none absolute bottom-14 left-2 right-2 z-[27] flex justify-center md:bottom-auto md:left-1/2 md:right-auto md:top-3.5 md:-translate-x-1/2 md:px-4">
        <div
          data-viewer-ui
          className="pointer-events-auto flex w-full max-w-full flex-wrap items-center gap-1.5 rounded-[11px] border border-white/10 bg-[rgba(20,23,28,0.9)] px-2 py-1 text-xs text-[#eef1f5] shadow-[0_12px_34px_rgba(20,23,28,0.18)] backdrop-blur-[10px] md:w-auto md:max-w-[min(100vw-2rem,36rem)] md:gap-2.5 md:px-3 md:py-2 md:text-[13px] md:leading-[normal]"
          onPointerDown={(event) => event.stopPropagation()}
        >
          <span
            className="grid h-5 w-5 flex-none place-items-center rounded-[7px] text-white md:h-6 md:w-6"
            style={{ background: pending.color || "#2b6ef0" }}
          >
            <Icon className="h-3 w-3 md:h-3.5 md:w-3.5" />
          </span>
          <span className="min-w-0 flex-1 md:min-w-[auto] md:flex-initial">
            {t("drawings.observation.placement_banner")}{" "}
            <b className="font-semibold text-white">
              {pending.title ||
                t(
                  pending.kind === "document_pin"
                    ? "drawings.observation.type.photo"
                    : `drawings.observation.type.${pending.kind}`
                )}
            </b>
          </span>
          {showSketchToggle ? (
            <>
              <span className="h-5 w-px bg-white/15" />
              <label className="inline-flex cursor-pointer items-center gap-1.5 text-[12px] text-white/90 max-md:shrink-0">
                <input
                  type="checkbox"
                  className="rounded border-white/30"
                  checked={Boolean(pending.wantSketch)}
                  onChange={(event) => onWantSketchChange(event.target.checked)}
                />
                <span>{t("documentUpload.preview.enableSketch")}</span>
              </label>
            </>
          ) : null}
          <span className="h-5 w-px bg-white/15" />
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex items-center gap-1 rounded-[7px] px-2 py-1 text-[12px] font-semibold text-white/80 hover:bg-white/10 hover:text-white max-md:shrink-0"
          >
            <XMarkIcon className="h-4 w-4" />
            {t("common.cancel")}
          </button>
        </div>
      </div>
    </>
  );
};
